module.exports = "/_next/static/images/sa2-duotone-02feedc16ee84335892479fec0b71e89.svg";